// Make menu styles (by category scopes)
function makeMenuColors (categoryScopes) {
  let styles = {};
  for (let scope in categoryScopes) {
    styles = {
      ...styles,
      [`style_${scope}`]: {
        '&:hover, &.active': {
          backgroundColor: categoryScopes[scope].primary[50],
          color: [categoryScopes[scope].primary[500], '!important'],
        },
        borderRightColor: categoryScopes[scope].primary[500]
        // backgroundColor: categoryScopes[scope].primary[50],
      },
    }
  }
  return styles;
}

export default theme => {
  const categoryScopeStyles = makeMenuColors(theme.palette.categoryScopes);
  let styles = {
    drawerPaper: {
      minWidth: 200,
    },
    buttonHolder: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: '#e5eaee',
      minWidth: 70
    },
    menu: {
    },
    menuItem: {
      borderRight: '6px solid',
      borderBottom: '1px solid #eee',
      textAlign: 'right',
      '&:last-child': {
        borderBottom: 'none'
      }
    },
    menuButton: {
      padding: 5,
      // marginRight: 20,
    },
    searchBox: {
      marginBottom: 8,
      border: 'none'
    },
    searchWrapper: {
      padding: '8px 0',
      [theme.breakpoints.up('sm')]: {
        display: 'none'
      }
    },
    socialIconsWrapper: {
      paddingTop: 5,
      [theme.breakpoints.up('sm')]: {
        display: 'none'
      }
    }
  };

  styles = {...styles, ...categoryScopeStyles};

  return styles;
}